export default function onMoveLeft(file) {
    let files = [...this.value];
    var index = files.indexOf(file);
    if (index < 1) return;
    files[index] = files[index - 1];
    files[index - 1] = file;
    this.$emit("input", files);
}
